{
  "app": {
    "brand": "Albüm Poster Oluşturucu",
    "headline": "Baskıya hazır albüm posteri yapın.",
    "description": "Bir albüm arayın, model seçin, posteri düzenleyin ve PNG olarak dışa aktarın."
  },
  "search": {
    "title": "Albüm verisi bul",
    "artist": "Sanatçı",
    "artistPlaceholder": "Kanye West",
    "title": "Başlık",
    "titlePlaceholder": "Kids See Ghosts",
    "year": "Yıl",
    "yearPlaceholder": "2018",
    "type": "Tür",
    "any": "Herhangi",
    "album": "Albüm",
    "ep": "EP",
    "single": "Single",
    "other": "Diğer",
    "search": "Ara",
    "searching": "Aranıyor…",
    "clear": "Temizle",
    "startManually": "Manuel başlat",
    "recent": "Son aramalar",
    "resultsFound": "{count} sonuç bulundu. | {count} sonuç bulundu.",
    "noResults": "Sonuç bulunamadı. Sorguyu değiştirin veya detayları manuel olarak girin.",
    "unknownArtist": "Bilinmeyen sanatçı",
    "unknownDate": "Bilinmeyen tarih",
    "noArt": "Kapak yok"
  },
  "models": {
    "back": "Aramaya dön",
    "title": "Poster modeli seçin",
    "subtitle": "Bir başlangıç noktası seçin. Sonrasında her alanı düzenleyebilirsiniz.",
    "cleanLabel": "Temiz",
    "cleanDesc": "Dengeli, modern poster. Kapak, parça listesi, palet — her şey yerli yerinde.",
    "atmosphereLabel": "Atmosfer",
    "atmosphereDesc": "Kapak görseli, geniş boşluklar ve zarif serif yazı tipinin arkasına yayılır."
  },
  "editor": {
    "previewTitle": "Önizleme",
    "previewCaption": "PNG dışa aktarımı sırasında yalnızca poster yüzeyi yakalanır.",
    "back": "Geri",
    "tabInformation": "Bilgi",
    "tabTracklist": "Parça Listesi",
    "tabStyle": "Stil",
    "albumDetails": "Albüm detayları",
    "title": "Başlık",
    "artist": "Sanatçı",
    "releaseDate": "Çıkış tarihi",
    "releaseDateAria": "Çıkış tarihi, örneğin 2018-06-08",
    "metadataLine": "Meta veri satırı",
    "artwork": "Kapak görseli",
    "artworkUrl": "Kapak URL'si",
    "uploadArtwork": "Kapak yükle",
    "tracklist": "Parça listesi",
    "showOnPoster": "Posterde göster",
    "oneTrackPerLine": "Her satıra bir parça",
    "tracklistHint": "Her satıra bir parça. Numaralar posterde otomatik eklenir.",
    "tracklistColumns": "Parça listesi sütunları",
    "column1": "1 sütun",
    "column2": "2 sütun",
    "column3": "3 sütun",
    "tracklistSize": "Parça listesi boyutu",
    "small": "Küçük",
    "medium": "Orta",
    "large": "Büyük",
    "typography": "Tipografi",
    "font": "Yazı tipi",
    "selectFont": "Yazı tipi seçin",
    "color": "Renk",
    "weight": "Kalınlık",
    "size": "Boyut",
    "italic": "İtalik",
    "uppercase": "Büyük harf",
    "sectionTitle": "Başlık",
    "sectionArtist": "Sanatçı",
    "sectionMetadata": "Tarih / meta veri",
    "sectionTracklist": "Parça listesi",
    "weightRegular": "Normal",
    "weightMedium": "Orta",
    "weightBold": "Kalın",
    "weightExtraBold": "Çok kalın",
    "weightBlack": "Siyah",
    "swatches": "Renk örnekleri",
    "paletteSwatches": "Palet renk örnekleri",
    "swatchShape": "Örnek şekli",
    "shapeSquare": "Kare",
    "shapeCircle": "Daire",
    "swatch": "Örnek {n}",
    "background": "Arka plan",
    "backgroundMode": "Mod",
    "modeDefault": "Varsayılan",
    "modeSolid": "Düz",
    "modeGradient": "Gradyan",
    "modeArtwork": "Kapak görseli",
    "backgroundColor": "Arka plan rengi",
    "from": "Başlangıç",
    "to": "Bitiş",
    "direction": "Yön",
    "horizontal": "Yatay",
    "vertical": "Dikey",
    "radial": "Radyal",
    "artworkBackgroundCaption": "Albüm kapağı poster arka planını dolduracak. Başlık üstte kalacak.",
    "frostedOverlay": "Buzlu katman",
    "blurLevel": "Bulanıklık seviyesi",
    "layout": "Yerleşim",
    "spacing": "Boşluk",
    "layoutEdgeToEdge": "Kenardan Kenara",
    "fontGotham": "Gotham (yerleşik sans-serif)",
    "fontInter": "Inter (yerleşik sans-serif)",
    "fontSystem": "Sistem varsayılanı"
  },
  "export": {
    "title": "Dışa Aktar",
    "printPreset": "Baskı ön ayarı",
    "selectPreset": "Baskı ön ayarı seçin",
    "exportPng": "PNG olarak dışa aktar",
    "exporting": "Dışa aktarılıyor…",
    "presetLabel": "{label} · {width}×{height} px"
  },
  "presets": {
    "a4-portrait": "A4 Dikey",
    "a3-portrait": "A3 Dikey",
    "poster-12x18": "12×18 Poster",
    "poster-50x70cm": "50×70 cm Poster",
    "poster-40x60cm": "40×60 cm Poster",
    "poster-30x40cm": "30×40 cm Poster",
    "square": "Kare Poster"
  },
  "preview": {
    "ariaLabel": "Albüm posteri önizlemesi",
    "artworkAlt": "{title} kapağı",
    "addArtwork": "Kapak ekle",
    "untitledAlbum": "İsimsiz Albüm",
    "releaseDate": "Çıkış tarihi",
    "unknownArtist": "Bilinmeyen Sanatçı",
    "paletteAria": "Poster paleti",
    "tracklistAria": "Parça listesi"
  },
  "editionDialog": {
    "title": "Sürüm seçin",
    "description": "Bu albümün MusicBrainz'de birden fazla sürümü var. Posterde kullanılacak parça listesi ve tarihi içeren sürümü seçin.",
    "unknownDate": "Bilinmeyen tarih",
    "tracks": "{count} parça",
    "cancel": "İptal"
  },
  "status": {
    "chooseEdition": "Albüm sürümünü seçin, tam parça listesini yükleyin.",
    "selectionCancelled": "Albüm seçimi iptal edildi.",
    "albumLoaded": "Albüm verileri yüklendi. Her alanı değiştirebilirsiniz.",
    "chooseModel": "Poster modeli seçin, ardından detayları manuel olarak düzenleyin.",
    "modelApplied": "Poster modeli uygulandı. Detayları inceleyin veya hazır olduğunuzda dışa aktarın.",
    "notReady": "Poster önizlemesi dışa aktarıma hazır değil.",
    "preparing": "PNG dışa aktarımı hazırlanıyor…",
    "exported": "{preset} PNG dışa aktarıldı.",
    "exportFailed": "PNG dışa aktarımı başarısız oldu. Başka bir ön ayar deneyin.",
    "artworkLookupFailed": "Kapak görseli araması başarısız oldu. Manuel olarak ekleyin.",
    "searchFailed": "MusicBrainz araması başarısız oldu."
  },
  "aria": {
    "toggleTheme": "{mode} moduna geç",
    "light": "aydınlık",
    "dark": "karanlık"
  },
  "language": {
    "label": "Dil",
    "en": "English",
    "tr": "Türkçe"
  }
}
